import { Container } from "components";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "services/api";

export const PartnerDetails = () => {
  const params = useParams();
  const [partner, setPartner] = useState([]);

  const fetchParticularData = async () => {
    try {
      const response = await api.get(`/partners/${params.id}`);
      setPartner(response?.data?.data?.partner);
      console.log("fetchParticularData:", response?.data?.data?.partner);
    } catch (error) {
      console.log("fetchParticularData error:", error);
    }
  };
  useEffect(() => {
    fetchParticularData();
  }, []);
  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <div className="col-xl-4 col-lg-5 col-md-5 order-1 order-md-0"></div>
          <div className="container-xxl flex-grow-1 container-p-y">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <Link to="/partners">Partners</Link>
                </li>
                <li class="breadcrumb-item active ">Partner details</li>
              </ol>
            </nav>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card mb-4">
                  <div className="card-body">
                  {partner?.logo_url && (
                    <div className="mb-3 d-flex align-items-center">
                      <img
                        src={partner.logo_url}
                        alt={`Logo of ${partner?.name || 'partner'}`}
                        style={{ maxHeight: "100px", maxWidth: "100%", objectFit: "contain", border: "1px solid #eee", padding: "4px", borderRadius: "4px" }}
                      />
                    </div>
                  )}
                    <div className="row">
                      <div className="col-md-4 col-12">
                        <small className="card-text text-uppercase">
                          About
                        </small>
                        <ul className="list-unstyled mb-4 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-user text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Name
                            </span>
                            <span>{partner?.name}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-mail text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Email
                            </span>
                            <span>{partner?.email}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-box-model text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Cashback Percentage %
                            </span>
                            <span>{partner?.price}%</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-phone-call text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Office Contact Number
                            </span>
                            <span>{partner?.contact_info}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-user text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Contact Person
                            </span>
                            <span>{partner?.contact_person}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-phone text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Partner Contact Number
                            </span>
                            <span>{partner?.contact_number || partner?.partner_contact_number}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-toggle-left text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Status
                            </span>
                            <span>
                              <span className={`badge ${partner?.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                                {partner?.status || 'Active'}
                              </span>
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-calendar text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Contract Start Date
                            </span>
                            <span>{partner?.contract_start_date ? moment(partner.contract_start_date).format("DD-MM-YYYY") : 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-calendar text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Contract End Date
                            </span>
                            <span>{partner?.contract_end_date ? moment(partner.contract_end_date).format("DD-MM-YYYY") : 'N/A'}</span>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-8 col-12">
                        <ul className="list-unstyled mb-4 mt-3">
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-category text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Categories
                            </span>
                            <span>
                              {partner?.categories && partner.categories.length > 0 ? (
                                partner.categories.map((cat, index) => (
                                  <span key={cat.category_id || index}>
                                    {cat.name}
                                    {index < partner.categories.length - 1 && ', '}
                                  </span>
                                ))
                              ) : (
                                <span className="text-muted">No categories</span>
                              )}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-smart-home text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Services
                            </span>
                            <span>
                              {partner?.industries && partner.industries.length > 0 ? (
                                partner.industries.map((ind, index) => (
                                  <span key={ind.industry_id || ind.id || index}>
                                    {ind.name}
                                    {index < partner.industries.length - 1 && ', '}
                                  </span>
                                ))
                              ) : partner?.industry ? (
                                <span>{partner.industry.name}</span>
                              ) : (
                                <span className="text-muted">No services</span>
                              )}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Location (City)
                            </span>
                            <span>{partner?.city?.name || partner?.city_id || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-top mb-3">
                            <i className="ti ti-file-text text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Description
                            </span>
                            <span 
                              className="flex-grow-1"
                              dangerouslySetInnerHTML={{__html:partner?.description || '<span class="text-muted">No description</span>'}}/>
                          </li>
                          <li className="d-flex align-items-top mb-3">
                            <i className="ti ti-files text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Exclusions
                            </span>
                            <span 
                              className="flex-grow-1"
                              dangerouslySetInnerHTML={{__html:partner?.exclusions || '<span class="text-muted">No exclusions</span>'}}/>
                          </li>
                          <li className="d-flex align-items-top mb-3">
                            <i className="ti ti-id text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Inclusions
                            </span>
                            <span
                              className="flex-grow-1"
                              dangerouslySetInnerHTML={{__html:partner?.inclusions || '<span class="text-muted">No inclusions</span>'}}/>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-bell text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Address
                            </span>
                            <span>{partner?.address || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Landmark
                            </span>
                            <span>{partner?.landmark || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Area Name
                            </span>
                            <span>{partner?.area_name || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Latitude
                            </span>
                            <span>{partner?.latitude || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-map-pin text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Longitude
                            </span>
                            <span>{partner?.longitude || 'N/A'}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="ti ti-calendar text-heading"></i>
                            <span className="fw-medium mx-2 text-heading">
                              Created at
                            </span>
                            <span>{partner?.created_at ? moment(partner.created_at).format("DD-MM-YYYY") : 'N/A'}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
